<template>
  <v-overlay :value="showImpersonate"
             scroll-strategy="block"
             z-index="9999"
             @keydown.esc="hide">
    <select id="fromOrgSelector"></select>
  </v-overlay>
</template>

<script>
import Selectr from 'mobius1-selectr/src/selectr';
import DashboardService from "../../modules/assurance/services/dashboard.service";
import DataProvider from "../../app/data-framework/data-provider";
import WebResourceSecure from "../../modules/assurance/services/web-resource-secure.service";
import LoginService from "../../services/login.service";

export default {
  name: "impersonationPanel",
  props: {
    show: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      showImpersonate: false,
      dataProvider: DataProvider.getInstance(),
    };
  },
  mounted() {
    let self = this;

  },
  methods: {
    hide: function () {
      let self = this;
      if (self.showImpersonate) {
        self.showImpersonate = false;
        self.fromOrgSelctr.clear();
        self.fromOrgSelctr.removeAll();
        self.$emit('impersonate-complete', self.filters);
      }
    }
  },
  watch: {
    show: function (newVal, oldVal) {
      let self = this;
      if (newVal) {
        DashboardService.fetchAllOrgsTemp().then(orgs => {
          let data = [];

          orgs.forEach(org => {
            if (!org.deleted) {
              data.push({value: org.id, text: org.id + " : " + org.name})
            }
          });
          
          self.showImpersonate = newVal;
          self.$nextTick(args => {
  

            self.fromOrgSelctr = new Selectr('#fromOrgSelector', {
              customClass: 'impersonation-selectr',
              width: 350,
              defaultSelected: false,
              placeholder: 'Select a Org to impersonate admin ...',
              data: data,
            });

            self.fromOrgSelctr.on('selectr.close', function (option) {
              self.hide();
            });
            
            self.fromOrgSelctr.on('selectr.select', function (option) {
              self.hide();
              // impersonate 
              DashboardService.fetchUsersForOrgTemp(option.value).then(users => {
                users.some(user => {
                  if (!user.deleted && user.login.startsWith('vyoptaadmin@')) {

                    self.dataProvider.logAdminActivity(option.value, 'impersonation', 'impersonationPanel.vue', 'impersonating orgId ' + option.value + ' user ' + user.id, {orgId: option.value, userId: user.id});

                    self.dataProvider.fetchAdminServiceBaseBaseURL()
                        .then(function (adminBaseUrl) {
                          let userId = LoginService.userObject.userId;

                          var url = adminBaseUrl + `/orgs/${option.value}/users/${user.id}/token?userId=${userId}`;
                          return WebResourceSecure.getJSON(url, undefined, 'GET', 'text');
                        }).then(response => {
                      const currentUrl = window.location.href;
                      let baseUrl = currentUrl.split(/\/?[?#]/)[0];
                      let app = currentUrl.includes('#/historical2') || currentUrl.includes('/#historical2') ?
                          'historical2' : currentUrl.includes('#/rooms') || currentUrl.includes('/#rooms') ?
                              'rooms' : currentUrl.includes('#/admin') || currentUrl.includes('/#admin') ?
                                  'admin' : 'monitoring';

                      let url = baseUrl + "/#/login/" + response + "/" + user.login + "/url/" + app;
                      console.log("impersonate url", url);
                      window.open(url, '_blank');
                    });

                    return true;
                  }
                });
              }).catch(err => {
                self.hide();
              });

            });

            self.fromOrgSelctr.open();
            let input = self.$el.getElementsByClassName('selectr-input');

            [...input].forEach(i => {
              i.focus();
            });

          });

        }).catch(err => {
          self.$emit('impersonate-complete', self.filters);
        });
      }
    },
  }
}
</script>

<style lang="scss">
.impersonation-selectr {
  width: 350px;
  color: var(--text-color);
}
</style>